export enum TenantTypeIds {
  Owner = '6F53C547-D2C7-4EEE-844C-6E5268A16CE9',
  Client = 'FAB9ADE8-8586-4BBD-9291-FE9A3AFA275C',
  Contractor = 'EABAF483-D94E-4090-A270-DFA6A5C350A9',
  OperationalClient = 'E6F4A13E-141C-4569-9715-A05ACF5BA952',
}
